import { Button } from "primereact/button";
import EmbeddedHelp from "../../app/common/EmbeddedHelp/EmbeddedHelp";
import "./Login.css";
import { appConfig } from "../../config";
import React, { useEffect, useState } from "react";

// const Login = ({ loginButtonClicked, siteName }) => {
//   return (
//     <div className="BackgroundLogin" >
//       <div className="LandingLogin">
//         <div className="LandingWrap">
//           <div className="LandingLoginBox">
//             <h1>Target & Project Tracker</h1>
//             <h5>[LOGIN]</h5>
//             <p>Please login with your BMGF ID to continue</p>
//             <Button
//               label="Login with SSO"
//               onClick={() => loginButtonClicked()}
//             ></Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

const Login = ({ loginButtonClicked }) => {
  const [siteName, setSiteName] = useState("");

  useEffect(() => {
    // Fetch site name from public endpoint (no auth required)
    const baseUrl = appConfig.REACT_APP_WEB_API_BASE_URI || "";
    if (baseUrl) {
      fetch(baseUrl + "/public/app-vars")
        .then(r => r.json())
        .then(data => {
          if (data && data.siteName) setSiteName(data.siteName);
        })
        .catch(() => {
          // Fallback: use default
        });
    }
  }, []);

  return (
    <div className="BackgroundLogin">
      {/* <div className="LoginLeft">
        <div className="centered"></div>
      </div> */}

      <div className="LoginRight">
        <div className="LoginCentered">
          <div className="LoginLanding">
            <div>
              <div className="LoginLoginBox" id="loginButton">
                <h1>{siteName || ""}</h1>

                <h5>[LOGIN]</h5>
                <p>
                  This computer system and the data herein are available only
                  for authorized purposes by authorized users: use for any other
                  purpose is prohibited and may result in administrative /
                  disciplinary actions or criminal prosecution against the user.
                  Usage may be subject to security testing and monitoring.
                </p>
                <p>
                  本平台及其包含的数据仅限授权用户使用，违者可能面临行政/纪律处分或刑事起诉，
                  使用情况可能受到安全测试与监控。
                </p>
                <EmbeddedHelp>
                  This is a demo implementation of {siteName || ""} framework, data
                  inside the App might not be accurate.
                </EmbeddedHelp>
                <br />
                <Button
                  label="Login with SSO"
                  onClick={() => loginButtonClicked()}
                ></Button>

                {/* <Footer /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;